import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";

import { useSearchContext } from "@/features/search/context/SearchContext";
import { formatResultCount } from "@/features/search/utils/count-placeholder.utils";

/** "1.234 resultaten", locale-grouped — total from the API's pageInfo. */
export const ResultsCount = () => {
  const { t } = useTranslation();
  const { locale } = useRouter();
  const { query } = useSearchContext();
  const total = query.data?.pageInfo.total;

  if (total == null) {
    return null;
  }

  return (
    <p className="font-body text-sm text-grey-500">
      {t("listing:search-results-count", {
        count: total,
        // Plural form follows `count`; the shown number is locale-grouped.
        replace: { count: formatResultCount(total, locale) },
      })}
    </p>
  );
};
